<template>
  <div class="commission-container">
    <van-nav-bar 
      title="佣金详情" 
      left-text="" 
      left-arrow 
      @click-left="onClickLeft" 
      @click-right="onClickRight" 
      :style="{ backgroundColor: '#FFD700', color: '#333333' }"
      :title-style="{ color: '#333333' }"
      :left-arrow-style="{ color: '#333333' }"
    />
    <div class="custom-tabs">
      <div class="tabs-header">
        <div 
          v-for="(tab, i) in tabs" 
          :key="i"
          class="tab-item"
          :class="{ active: active === i }"
          @click="onTabClick(i)"
        >
          {{ tab.name }}
        </div>
      </div>
      <div class="tabs-content">
        <div v-for="(tab, i) in tabs" :key="i" v-show="active === i">
          <div class="search-section">
            <div class="custom-search">
              <div class="search-input-wrap">
                <input
                  type="text"
                  class="search-input"
                  v-model="tab.search"
                  placeholder="输入用户ID"
                  @keyup.enter="onSearch"
                />
              </div>
              <div class="search-action-btn" @click="onSearch">搜索</div>
            </div>
            <div class="search-type">
              <div class="custom-radio-group" :class="{ horizontal: true }">
                <div 
                  class="radio-option"
                  :class="{ checked: tab.checked === '0' }"
                  @click="tab.checked = '0'"
                >
                  <div class="radio-icon"></div>
                  <span>用户ID</span>
                </div>
                <div 
                  class="radio-option"
                  :class="{ checked: tab.checked === '1' }"
                  @click="tab.checked = '1'"
                >
                  <div class="radio-icon"></div>
                  <span>上级ID</span>
                </div>
              </div>
            </div>
          </div>
          <div class="content-area">
            <div v-if="tab.list.length === 0 && !tab.loading" class="empty-state">
              <div class="empty-icon">📄</div>
              <p class="empty-text">暂无分成数据</p>
            </div>
            <div v-else>
              <div class="commission-card" v-for="(li, i) in tab.list" :key="i">
                <div class="card-header">
                  <div class="time">{{ getDisplayDate(li) }}</div>
                  <div class="state" :class="getStateClass(li.state)">{{ li.state == 0 ? "未结算" : li.state == 1 ? "可结算" : "已结算" }}</div>
                </div>
                <div class="card-content">
                  <div class="user-info">
                    <div class="name">{{ li.userInfo.nickName }}</div>
                    <div class="uid">ID: {{ li.userId }}</div>
                  </div>
                  <div class="income-info">
                    <div class="income-amount">{{ formatIncome(li) }}</div>
                    <div class="income-type">{{ li.type == 0 ? getTypeIncomeDesc(li) : "成员分成" }}</div>
                  </div>
                </div>
              </div>
              <div v-if="tab.loading" class="loading-state">
                <div class="loading-spinner"></div>
                <span>加载中...</span>
              </div>
              <div v-if="tab.finished && tab.list.length > 0" class="finished-state">
                没有更多了
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Mask v-if="marke"></Mask>
  </div>
</template>
<script>
// import { wxqq } from '../utils/utils'
import Mask from '../components/Mask'
import routerUtil from '../utils/routerUtil'
import { Toast } from "vant";

export default {
  name: 'Comission',
  data() {
    return {
      groupInfo: null,
      active: 0,
      tabs: [
        {
          name: '本周期',
          search: '',
          searchUid: null,
          checked: '0',
          searchType: 0,
          loading: false,
          finished: false,
          refreshing: false,
          list: [],
        },
        {
          name: '历史周期',
          search: '',
          searchUid: null,
          checked: '0',
          searchType: 0,
          loading: false,
          finished: false,
          refreshing: false,
          list: [],
        },
      ],
      marke: false,
    }
  },
  components: {
    Mask,
  },
  mounted() {
    if (this.$route.params.userId) {
      this.search = this.$route.params.userId
      this.searchUid = parseInt(this.search);
    }
    this.reqInfo()
    // this.marke = wxqq()
  },
  methods: {
   getTypeIncomeDesc(li) {
  // 收集所有符合条件的描述
  const descList = [];
  
  if (li.num !== 0) {
    descList.push("组长分成");
  }
  if (li.oneincome !== 0) {
    descList.push("邀请组分成");
  }
  if (li.topOwnerIncome !== 0) {
    descList.push("一级组分成");
  }
  
  // 用 "- " 连接所有有效描述（自动处理分隔符，无多余符号）
  return descList.join("/");
}
,
    reqInfo() {
      this.$request.postJson('/api/user/pay_group/info', {})
        .then((res) => {
          if (res.data.code == 0) {
            this.groupInfo = res.data.data;
            if (!this.groupInfo) {
              Toast('暂无推广组信息');
              routerUtil.back()
              return;
            }
            this.getList()
          }
        })
    },
      formatIncome(li) {
      const { num, oneincome, topOwnerIncome } = li;
      
      // 过滤规则：值不为null、不为undefined、且不为0
      const validValues = [num, oneincome, topOwnerIncome]
        .filter(value => value !== null && value !== undefined && value !== 0);
      
      return validValues.join('/');
    },
    getList(type) {
      const tab = this.tabs[this.active];
      let lastId = ''
      if (type && tab.list.length > 0) {
        lastId = tab.list[tab.list.length - 1].id
      }
      this.$request.postJson('/api/user/pay_group/share_logs', {
        groupId: this.groupInfo.id,
        periodType: this.active,
        userType: tab.searchType,
        userId: tab.searchUid == null ? 0 : tab.searchUid,
        lastId: lastId,
        pageSize: 15
      }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.logs.length == 0) {
            tab.loading = false;
            tab.refreshing = false
            tab.finished = true;
            return
          }
          const uids = [];
          for (let log of res.data.data.logs) {
            uids.push(log.userId);
          }
          this.$request.post('/api/user/info/userInfoByGroup', { userIds: JSON.stringify(uids) })
            .then((res1) => {
              tab.loading = false;
              tab.refreshing = false
              if (res1.data.code == 0) {
                const userMap = new Map();
                for (let user of res1.data.data.users) {
                  if (user.code == 0) {
                    userMap.set(user.userId, user);
                  } else {
                    Toast("请求用户基本信息失败")
                    return;
                  }
                }
                for (let log of res.data.data.logs) {
                  log.userInfo = userMap.get(log.userId);
                }
                tab.list.push(...res.data.data.logs)
                tab.finished = res.data.data.logs.length < 15
              }
            })
        }
      })
    },
    onClickLeft() {
      routerUtil.back()
    },
    onClickRight() {
    },
    onTabClick(index) {
      this.active = index;
      const tab = this.tabs[index];
      if (!tab.loading && !tab.finished && tab.list.length === 0) {
        this.getList()
      }
    },
    onSearch() {
      const tab = this.tabs[this.active];
      if (tab.search == "") {
        tab.searchUid = null
      } else {
        if (isNaN(Number(tab.search, 10))) {
          Toast("请输入用户ID")
          return
        }
        const uid = parseInt(tab.search);
        tab.searchUid = uid;
      }
      tab.searchType = parseInt(tab.checked)
      tab.list = []
      this.onRefresh()
    },
    onLoad() {
      this.getList(true)
    },
    onRefresh() {
      const tab = this.tabs[this.active];
      // 清空列表数据
      tab.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      tab.loading = true;
      this.getList()
    },
    getDisplayDate(li) {
      const dateBegin = new Date(li.startTime);
      const monthBegin = dateBegin.getMonth() + 1;
      const dayBegin = dateBegin.getDate();
      const dateEnd = new Date(li.endTime);
      const monthEnd = dateEnd.getMonth() + 1;
      const dayEnd = dateEnd.getDate();
      return `${dateBegin.getFullYear()}/${monthBegin > 9 ? monthBegin : '0' + monthBegin}/${dayBegin > 9 ? dayBegin : '0' + dayBegin} 至 ${dateEnd.getFullYear()}/${monthEnd > 9 ? monthEnd : '0' + monthEnd}/${dayEnd > 9 ? dayEnd : '0' + dayEnd}`;
    },
    // 添加状态样式类名方法
    getStateClass(state) {
      switch(state) {
        case 0:
          return 'state-unsettled';
        case 1:
          return 'state-settlable';
        case 2:
          return 'state-settled';
        default:
          return '';
      }
    }
  },
}
</script>
<style scoped lang="less">
// 全局样式重置
.commission-container {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #fafafa 0%, #ffffff 100%);
  font-size: 14px;
  color: #999999;
  padding: 16px;
}

// 搜索区域
.search-section {
  background: #ffffff;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}



// 搜索类型选择
.search-type {
  padding: 8px 0;
}

// 搜索按钮样式
.search-action {
  color: #333333 !important;
  font-weight: 500;
}

// 自定义搜索框样式
.custom-search {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  
  .search-input-wrap {
    flex: 1;
    position: relative;
    background: #f5f5f5;
    border-radius: 20px;
    padding: 0 16px;
    height: 40px;
    display: flex;
    align-items: center;
    border: 1px solid #e0e0e0;
    
    .search-input {
      flex: 1;
      background: transparent;
      border: none;
      outline: none;
      color: #333333;
      font-size: 14px;
      height: 100%;
      
      &::placeholder {
        color: #999999;
        font-size: 14px;
      }
    }
  }
  
  .search-action-btn {
    color: #333333;
    font-size: 14px;
    padding: 0 16px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFD700;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      background: #ffc700;
    }
  }
}

// 内容区域
.content-area {
  padding: 12px 16px;
}

// 空状态
.empty-state {
  text-align: center;
  padding: 40px 0;
  
  .empty-text {
    margin-top: 12px;
    color: #666666;
    font-size: 14px;
  }
  
  :deep(.van-icon) {
    color: #cccccc !important;
  }
}

// 分成卡片
.commission-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #cccccc;
  }
}

// 卡片头部
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  
  .time {
    font-size: 13px;
    color: #333333;
  }
  
  .state {
    font-size: 13px;
    padding: 2px 8px;
    border-radius: 10px;
    font-weight: 500;
    
    &.state-unsettled {
      background: #e0e0e0;
      color: #333333;
    }
    
    &.state-settlable {
      background: #cccccc;
      color: #333333;
    }
    
    &.state-settled {
      background: #d0d0d0;
      color: #333333;
    }
  }
}

// 卡片内容
.card-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

// 用户信息
.user-info {
  flex: 1;
  
  .name {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 4px;
  }
  
  .uid {
    font-size: 13px;
    color: #333333;
  }
}

// 收益信息
.income-info {
  text-align: right;
  
  .income-amount {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 4px;
  }
  
  .income-type {
    font-size: 13px;
    color: #333333;
    background: #e0e0e0;
    padding: 2px 6px;
    border-radius: 4px;
  }
}

// 自定义标签页样式
.custom-tabs {
  width: 100%;
  margin-bottom: 20px;
  
  .tabs-header {
    display: flex;
    background: #ffffff;
    border-radius: 8px 8px 0 0;
    overflow: hidden;
    border: 1px solid #e0e0e0;
    border-bottom: none;
    
    .tab-item {
      flex: 1;
      padding: 16px 0;
      text-align: center;
      font-size: 15px;
      color: #999999;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      
      &:hover {
        color: #333333;
        background: rgba(255, 215, 0, 0.1);
      }
      
      &.active {
        color: #333333;
        font-weight: 600;
        background: rgba(255, 215, 0, 0.15);
        
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 20%;
          right: 20%;
          height: 3px;
          background: #FFD700;
          border-radius: 3px 3px 0 0;
        }
      }
    }
  }
  
  .tabs-content {
    background: #ffffff;
    border-radius: 0 0 8px 8px;
    padding: 16px;
    min-height: 400px;
  }
}

// 自定义单选按钮样式
.custom-radio-group {
  display: flex;
  gap: 20px;
  
  &.horizontal {
    flex-direction: row;
  }
  
  .radio-option {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 4px 0;
    
    .radio-icon {
      width: 16px;
      height: 16px;
      border: 2px solid #cccccc;
      border-radius: 50%;
      transition: all 0.3s ease;
      
      &::after {
        content: '';
        display: none;
        width: 8px;
        height: 8px;
        background: #333333;
        border-radius: 50%;
        margin: 2px;
      }
    }
    
    span {
      font-size: 14px;
      color: #333333;
      transition: all 0.3s ease;
    }
    
    &.checked {
      .radio-icon {
        border-color: #666666;
        background: #cccccc;
        
        &::after {
          display: block;
        }
      }
      
      span {
        font-weight: 500;
      }
    }
  }
}

// 加载状态样式
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  color: #666666;
  font-size: 14px;
  
  .loading-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid #cccccc;
    border-top: 2px solid #333333;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
}

// 结束状态样式
.finished-state {
  text-align: center;
  padding: 20px 0;
  color: #666666;
  font-size: 14px;
}

// 导航栏样式
:deep(.van-nav-bar) {
  background-color: #FFD700 !important;
  color: #333333;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  
  &__title {
    color: #333333;
    font-weight: 500;
  }
  
  &__left {
    color: #333333;
    
    .van-icon {
      color: #333333 !important;
    }
  }
}

// 列表样式覆盖
:deep(.van-list) {
  padding: 0;
  
  &__loading,
  &__finished-text {
    color: #666666;
    font-size: 13px;
    padding: 16px 0;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .search-section {
    padding: 10px 12px;
  }
  
  .content-area {
    padding: 10px 12px;
  }
  
  .commission-card {
    padding: 14px;
    margin-bottom: 10px;
  }
  
  .income-amount {
    font-size: 16px !important;
  }
  
  .name {
    font-size: 15px !important;
  }
}
</style>
